const layout = document.querySelector('body') as HTMLElement;

export const scrollAvailable = () => {
    layout.style.overflowY = 'scroll';
};
export const scrollNotAvailable = () => {
    layout.style.overflowY = 'hidden';
};
